import * as React from 'react'

const SvgShareIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.375 12.5a3.125 3.125 0 00-2.431 1.181l-4.569-2.856a2.788 2.788 0 000-1.65l4.569-2.856a3.125 3.125 0 10-.694-1.944c.003.28.045.557.125.825L6.806 8.056a3.125 3.125 0 100 3.888l4.569 2.856a2.99 2.99 0 00-.125.825 3.125 3.125 0 103.125-3.125zm0-10a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm-10 9.375a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75zm10 5.625a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgShareIcon
